/**
 * Direct Routing Strategy
 *
 * Default routing strategy - no routing logic.
 * Edges go directly from source to target without waypoints.
 */

import type { GfxModel } from '@blocksuite/std/gfx';

import type { EdgeRoutingType, RoutedEdge, StreamlainEdge } from '../../types';
import type { IEdgeRoutingStrategy } from './types';

/**
 * Pass-through routing strategy
 *
 * Returns edges without modification. No collision avoidance
 * or path optimization is performed.
 */
export class DirectRoutingStrategy implements IEdgeRoutingStrategy {
  readonly type: EdgeRoutingType = 'direct';

  route(edges: StreamlainEdge[], _elements: GfxModel[]): RoutedEdge[] {
    // Pass-through - no routing logic
    return edges.map(edge => ({
      ...edge,
      waypoints: undefined,
    }));
  }
}
